<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            max-width="650px"
        >
        <v-card>
            <v-card-title>
                <span class="text-h5">Order Detail</span>
            </v-card-title>

            <v-list class="pa-2">
                <v-list-item>
                    <v-list-item-title>
                        Order No
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right black--text">
                        {{ order.order_no }}
                    </v-list-item-subtitle>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-title>
                        Merchant
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right black--text">
                        {{ order.merchant }}
                    </v-list-item-subtitle>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-title>
                        Plan
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right black--text">
                        {{ order.plan }}
                    </v-list-item-subtitle>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-title>
                        Amount
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right black--text">
                        RM{{ order.amount }}
                    </v-list-item-subtitle>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                    <v-list-item-title>
                        Date
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right black--text">
                        {{ order.date }}
                    </v-list-item-subtitle>
                </v-list-item>
            </v-list>


            <v-card-text>

                <div class="title">Attachment</div>
                <v-row>
                    <v-col
                        v-for="receipt in order.receipts"
                        :key="n"
                        class="d-flex child-flex"
                        cols="3"
                    >
                    <a :href="receipt.path" target="_blank">
                        <v-img
                            :src="receipt.path"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                            <template v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                                ></v-progress-circular>
                            </v-row>
                            </template>
                        </v-img>
                    </a>


                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    @click="dialog = false"
                >
                    Close
                </v-btn>
                <v-btn
                    color="error"
                    @click="reject"
                >
                    Reject
                </v-btn>
                <v-btn
                    color="success"
                    @click="approve"
                >
                    Approve
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
  </v-row>
</template>

<script>
export default {
    props: ['value', 'order_id'],

    data() {
        return {
            dialog: false,
            order: null,
        }
    },

    created() {
        this.dialog = this.value;
    },

    methods: {
        updateValue(val) {
            this.$emit('input', val)
        },

        getOrder() {
            axios.get(api.path('order.detail', {id: this.order_id})).then(res => res.data).then(res => {
                this.order = res.data
            })
            .catch(error => {
                console.log(error);
            })
        },

        approve() {
            this.submit('approve');
        },

        reject() {
            this.submit('reject');
        },

        submit(type) {
            axios.post(api.path('order.update'), {id: this.order.id, type: type}).then(res => res.data).then(res => {
                this.$toastr.s(res.message);
                this.dialog = false;
                this.$emit('refresh');
            })
            .catch(error => {
                this.$toastr.e(error.response.data.message);
            })
        }
    },

    watch: {
        dialog(newVal, oldVal) {
            if(newVal !== oldVal) this.updateValue(newVal)
        },

        value(newVal, oldVal) {
            if(newVal !== oldVal) this.dialog = newVal;
        },

        order_id(newVal, oldVal) {
            if(newVal !== oldVal) {
                this.getOrder();
            }
        }
    }
}
</script>
<style lang="">

</style>